let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("33hok")).then(() => parcelRequire('gcdUq'));